import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useWorkspace } from '@/api/workspace'
import { LoadingSkeleton } from '@/components/loading-skeleton'
import { SetupWizard } from '@/components/product-setup/setup-wizard'
import { ProductForm } from '@/components/products/product-form'

// Product create (UI-SCREENS P-02, #99). Owner only; the API refuses Staff too. With the
// `product_setup` feature flag on, the guided setup wizard instead.
export const Route = createFileRoute('/w/$slug/products/new')({
  component: NewProduct,
  staticData: { breadcrumb: 'products.form.newTitle' },
})

function NewProduct() {
  const { t } = useTranslation()
  const { slug } = Route.useParams()
  const workspace = useWorkspace(slug)

  if (workspace.isPending) return <LoadingSkeleton variant="form" />
  if (workspace.data?.features.product_setup) return <SetupWizard slug={slug} step="product" />
  if (workspace.data && workspace.data.role !== 'owner') {
    return <Navigate to="/w/$slug/products" params={{ slug }} replace />
  }

  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-heading text-xl font-semibold">{t('products.form.newTitle')}</h1>
      <ProductForm slug={slug} />
    </section>
  )
}
